<template>
  <div
    class="sidebar-container"
    :style="{ backgroundColor: appConfig.colors[0] }"
  >
    <div class="top-box">
      <img src="@/assets/img/logo.png" alt="logo" />
      <span>{{ appConfig.appName }}</span>
    </div>
    <el-menu
      :default-active="activeIndex"
      class="sidebar-menu"
      :background-color="appConfig.colors[0]"
      text-color="#fff"
      :active-text-color="appConfig.colors[1]"
      @select="handleSelect"
    >
      <el-menu-item v-for="item in routes" :key="item.path" :index="item.path">
        <img :src="item.icon" alt="icon" />
        <span>{{ item.name }}</span>
      </el-menu-item>
    </el-menu>
    <div
      class="bottom-box"
      @click="openAboutMsg"
      :style="{ backgroundColor: appConfig.colors[0] }"
    >
      <el-icon class="about-btn" :size="23" color="#fff"
        ><InfoFilled
      /></el-icon>
      <div>V_{{ appConfig.appVersion }}</div>
    </div>
    <div class="com-box">
      <AboutMsg ref="AboutMsgRef" />
    </div>
  </div>
</template>

<script setup>
import { InfoFilled } from "@element-plus/icons-vue";
import { ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import routes from "@/router/routeList";
import AboutMsg from "./AboutMsg.vue";

let appConfig = require("@/config/appConfig.json");
const router = useRouter();
const route = useRoute();
const AboutMsgRef = ref(null);

// 当前激活的菜单项
const activeIndex = computed(() => route.path);

// 处理菜单选择
const handleSelect = (path) => {
  router.push(path);
};

let openAboutMsg = () => {
  AboutMsgRef.value.open();
};
</script>
<style scoped lang="scss">
.sidebar-menu .el-menu-item {
  height: 60px;
}

.sidebar-menu .el-menu-item:hover {
  background-color: #00342c !important;
}

.sidebar-menu .el-menu-item.is-active {
  background-color: #00342c !important;
}
.sidebar-container {
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .top-box,
  .bottom-box {
    height: 50px;
    width: 100%;
    color: #fff;
  }
  .top-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5% 0;
    img {
      height: 25px;
      width: 25px;
      margin-right: 10px;
      border: 1px solid #fff;
      border-radius: 50%;
    }
    span {
      font-size: 1.2rem;
      font-weight: bolder;
    }
  }
  .sidebar-menu {
    padding: 20px 0px;
    height: 80%;
    width: 100%;
    border-right: 0px solid #e6e6e6;
    overflow: auto;
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    span {
      font-size: 1.3rem;
      font-weight: bolder;
    }
  }
  .bottom-box {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    padding: 5% 0;
    &:hover {
      cursor: pointer;
    }
    .about-btn {
      margin: auto 10px;
    }
    div{
      font-size: 1.1rem;
    }
  }
}
</style>
